// extracted by mini-css-extract-plugin
export var label = "_6k-1";
export var reminder = "_6k-0";